import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import {default as GridColumnsJSON} from './audit-trail-grid-columns.json';
import { ConstantService } from "app/Shared/Services/constant-service";
import { GridService } from "app/Shared/Services/grid.service";
import { HttpErrorResponse } from "@angular/common/http";
import { AuditTrailService } from "./audit-trail.service";
import { UserService } from "app/Shared/Services/user.service";
import { ButtonModule } from "primeng/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TableModule } from 'primeng/table';
import {MatExpansionModule} from '@angular/material/expansion';
import { FilterPanelComponent } from "../filter-panel/filter-panel.component";
import { JSONViewerComponent } from "../json-viewer/json-dialog.component";
import {MatChipsModule} from '@angular/material/chips';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { LowerCasePipe,NgClass, CommonModule  } from '@angular/common';

@Component({
    selector: 'app-audit-trail',
    imports: [NgClass, CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        FilterPanelComponent, JSONViewerComponent, MatChipsModule, MatProgressSpinnerModule, MatChipsModule,
         MatExpansionModule, LowerCasePipe
    ],
    templateUrl: './audit-trail.componenet.html',
    styleUrls: ['./audit-trail.componenet.scss']
})
export class AuditTrailComponent implements OnInit, OnChanges {
  @Input('SelectedRow') selectedRow: any = [];
  isDataLoading: boolean = false;
  @Input('showFilter') showFilter: boolean = false;
  @Input('staticFilter') staticFilter: boolean = true;
  @Input('rows') rows: number = 12;
  @Input('pageName') pageName!: string;
  gridColumns = GridColumnsJSON;
  DefaultFilterArray: any = [];
  isFilterLabelReset: boolean = false;
  cols = [];
  LastExecutionAuditDate!: any[];
  reportDate: string = "";
  orderID: string = "";
  symbol: string = "";
  type: string = "";
  side: string = "";
  orderDate: string = "";
  firmROEID: string = "";
  startLimit: number = 0;
  endLimit: number = 5000;
  totalRecords : number = 0;
  auditData: any = [];
  selectedJSONObject: any;
  originalJSONObject: any;
  isJsonViewer: boolean = false;
  selectedRowID: any;
  selectedRows: any[] = [];
  ri:any;

  constructor(public gridService: GridService,
    public constantService: ConstantService,
    public auditTrailService: AuditTrailService,
    public userService: UserService) {
    this.getColumns();
  }
  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit() {
    let todate: any;
    const rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.totalRecords = rowcount;
    todate = this.userService.getyyyyMMddDateFormate(this.userService.AuditLastExecutionDate);
    this.LastExecutionAuditDate = [];
    if (todate != "" || todate != undefined || todate != null) {
      this.LastExecutionAuditDate[0] = (todate);// Fromdate
      this.LastExecutionAuditDate[1] = (todate);// Todate
      this.defaultFilter();
    }
    this.loadData();
  }


  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'lastUpdate', 'filterby': '', 'values': this.LastExecutionAuditDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Firm ROEID', 'columnname': 'firmROEID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Symbol', 'columnname': 'symbol', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'User Id', 'columnname': 'user', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
    ];
  }

  loadData(){
    if (this.staticFilter) {
      this.getDialogClickData()
    }
    if (this.showFilter) {
      this.getDataOnFilter();
    }
  }

  getDialogClickData() {
    let row = this.selectedRow[0];
    this.firmROEID = row['firmROEID'];
    this.reportDate = row['reportDate'];
    this.type = row['type'];
    this.symbol = row['symbol'];
    let payload = {
      mpid: this.userService.getActiveMPID(),
      firmROEID: this.firmROEID,
      reportDate: this.reportDate,
      pageName:"audit-dialog",
      startLimit:this.startLimit,
      endLimit:this.endLimit
    };
    this.getData(payload);
  }

  changePage(event:any) {
    this.startLimit = event.first;
    this.endLimit = event.rows;
    this.loadData();
  }

  getDataOnFilter() {
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    if(filterData[0].values.length === 2) {
      filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    let payload = {
      data: this.DefaultFilterArray,
      mpid: this.userService.getActiveMPID(),
      pageName:"audit-details",
      startLimit:this.startLimit,
      endLimit:this.endLimit
    };
    this.getData(payload);

  }

  getData(payload:any){
    this.isDataLoading = true;
    this.auditTrailService.getData(payload)
    .subscribe({
      next: (Element:any) => {
        this.isDataLoading = false;
      let dataset: any = Element;
      if (dataset.data) {
        this.auditTrailService.dataArray = [];
        this.auditData = dataset.data;
        this.totalRecords = this.auditData.length;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        this.auditTrailService.dataArray = this.auditData;
        this.originalJSONObject = this.auditData.length > 0 ? this.auditData[this.auditData.length - 1].originalJSON : null;
      }
      },
      error: (err: HttpErrorResponse) => {
        this.isDataLoading = false;
      }
    });
  }


  getColumns() {
    let column: any = this.gridColumns;
    if (column != null || column != undefined) {
      this.cols = this.gridService.getGridColumnsOftree(column);
    }
  }

  exportToCSV() {
    if(this.userService.enableFileExport()){
    this.auditTrailService.exportToCSV(this.type, this.firmROEID, this.gridColumns, this.pageName, (typeof this.pageName!=='undefined' ? this.selectedRow : this.DefaultFilterArray));
    }
  }

  getResolutionHeight() {
    return this.constantService.getResolutionHeight() - 60 + 'px';
  }

  onJsonViewer(rowData:any) {
    this.selectedRows = [];
    this.selectedRows[0] = rowData;
    this.isJsonViewer = true;
    this.selectedJSONObject = rowData['updatedJSON'];
    if (this.showFilter) {
      this.originalJSONObject = rowData['originalJSON'];
    }
  }

  FilterApplyFilterEvent(event:any) {
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.getDataOnFilter();
  }


}